import { memo } from 'react';

import useOneTimeLogout from 'src/hooks/useOneTimeLogout';

const OneTimeLogout = () => {
  useOneTimeLogout();

  return null;
};

export default memo(OneTimeLogout);
